import { Http } from '@/model/Http.js'

export default class invite extends Http {
  //邀请好友列表
  getInviteList(data){
    const url = 'api/open-user/search'
    return this.postAjax(url, {
       ...data
    })
  }

  //已购套餐详情列表
  getPackageList(data){
    const url = 'api/open-user/search-package'
    return this.postAjax(url, {
      ...data
    })
  }

}



// WEBPACK FOOTER //
// ./src/javaApi/invite.js